<style type="text/css" media="screen">
#map{
	width: 100%;
	height: 400px;
}
</style>
<template>
	<div>
		<v-text-field
		v-model="theKeyword"
		id="ps-input"
		single-line
		outlined
		dense
		color="primary"
		>
	</v-text-field>
	<div id="map">
	</div>
	<p>
<!--		{{$store.state.map_center.lang}},-->
	</p>
</div>
</template>																																																																		
<script type="text/javascript">
import $Scriptjs from 'scriptjs';
export default{

	data(){
		return {
			map:null,
			center:{
				lat:21.2514,
				lng:81.6296
			},
			location:"",
			theKeyword:"",
			zoom:7,
		}
	},
	/* add watcher for thr Center  shipments*/ 
	watch: {
		center: {
			handler(newVal, oldVal){
				if(newVal != oldVal){
					// console.log("this.center")
					// console.log(this.center)
					this.intMap(this.center)
					// let myLatlng = new window.google.maps.LatLng(this.center.lat, this.center.lng);
					// this.updateMarker(myLatlng);

				}
			},
			deep: true
		}
	},
	mounted(){
		$Scriptjs('https://maps.googleapis.com/maps/api/js?key='+this.$keys.GOOGLE_PLACES_API_KEY+'&libraries=geometry,places',()=>{
			this.intMap(this.center);
			this.initMapAutocomplete();
			// this.updateMarker(this.center);
		});
	},
	methods:{
		intMap(center){
			console.log("init")
			this.map = new window.google.maps.Map(document.getElementById("map"),{
				center: center,
				zoom: this.zoom,
				mapTypeId: "terrain",

			});
			window.google.maps.event.addListener(this.map, "click", (event) => {
				this.lastLat = event.latLng.lat();
				this.lastLng = event.latLng.lng();
				this.updateMarker(event.latLng);
			});
			this.addMarker()

		},
		initMapAutocomplete() {
			this.geocoder = new window.google.maps.Geocoder();

			const input = document.getElementById('ps-input');
			const autocomplete = new window.google.maps.places.Autocomplete(input);

			window.google.maps.event.addListener(autocomplete, 'place_changed', () => {
				const place = autocomplete.getPlace();
				this.updateFromTextAddress(place)

			});
		},
		updateFromTextAddress(payload) {
			
			this.map.setCenter(payload.geometry.location);
			this.updateMarker(payload.geometry.location);
			this.map.setZoom(15);

		},

		updateMarker(latLng) {
			console.log("updateMarker")
			if (!this.marker) {
				this.marker = new window.google.maps.Marker({
					map: this.map,
				});
			}
			// this.map.setZoom(15);
			this.marker.setPosition(latLng);
			this.$store.dispatch('setMapCenter', {'lat':latLng.lat(),'lng':latLng.lng()})

			// this.$emit("update",latLng)
		},
		addMarker(){
			let map =this.map
			this.marker=new window.google.maps.Marker({
				position: this.center,
				map,
				// title: "Hello World!",
			});
		},
		deleteMarkers() {
			// clearMarkers();
		}


	}

}
</script>																																																																																																																																																																